module.exports = __webpack_public_path__ + "media/images/logo-ideal-558568c72e1d9a7674208210e31f8d10.png";